import {Stack} from '@mui/material';
import {Control, Controller, FieldErrors, UseFormRegister} from 'react-hook-form';
import {PROFILE_FIELDS} from '../../constants/profile-fields.constants';
import {ProfileFormValues} from '../../types/profile.types';
import {ActionsRow, PrimaryButton, SectionTitle} from '../profile.styles';
import {SimpleField} from '../simple-field';
import {PhoneMask} from '../../../../ui/phone-input/PhoneMask';

interface Props {
  control: Control<ProfileFormValues>;
  register: UseFormRegister<ProfileFormValues>;
  errors: FieldErrors<ProfileFormValues>;
  canSave: boolean;
  loading: boolean;
}

const PHONE_MESSAGE = 'Некорректный номер или добавочный';
const EMAIL_MESSAGE = 'Введите корректный адрес электронной почты';
const WEBSITE_MESSAGE = 'Введите корректный адрес сайта';
const phoneRegExp = /^(\+7 \([1-9]\d{2}\) \d{3}-\d{2}-\d{2}( #\d+)?$)/;

const isValidWebsite = (value: string) => {
  const normalizedValue = value.trim();
  if (!normalizedValue) return true;

  const valueWithProtocol = /^https?:\/\//i.test(normalizedValue) ? normalizedValue : `https://${normalizedValue}`;

  try {
    const url = new URL(valueWithProtocol);
    return Boolean(url.hostname && url.hostname.includes('.'));
  } catch {
    return false;
  }
};

export const ContactSection = ({control, register, errors, canSave, loading}: Props) => {
  return (
    <Stack gap="15px">
      <SectionTitle>Контактная информация</SectionTitle>
      <Stack direction={{xs: 'column', md: 'row'}} gap="32px">
        <Controller
          control={control}
          name={PROFILE_FIELDS.phone}
          rules={{
            required: 'Обязательное поле',
            pattern: {
              value: phoneRegExp,
              message: PHONE_MESSAGE,
            },
          }}
          render={({field: {value, onChange, ref}, fieldState: {error}}) => (
            <SimpleField
              ref={ref}
              label="Телефон"
              value={value || ''}
              onChange={onChange}
              error={!!error}
              helperText={error?.message}
              InputProps={{
                inputComponent: PhoneMask as never,
              }}
            />
          )}
        />
        <SimpleField
          label="Адрес электронной почты"
          {...register(PROFILE_FIELDS.email, {
            required: 'Обязательное поле',
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: EMAIL_MESSAGE,
            },
          })}
          error={!!errors.email}
          helperText={errors.email?.message}
        />
      </Stack>
      <Stack direction={{xs: 'column', md: 'row'}} gap="32px">
        <SimpleField
          label="Сайт компании"
          {...register(PROFILE_FIELDS.website, {
            validate: (value) => isValidWebsite(value || '') || WEBSITE_MESSAGE,
          })}
          error={!!errors.website}
          helperText={errors.website?.message}
        />
        <Stack width="100%" />
      </Stack>
      <ActionsRow direction="row">
        <PrimaryButton variant="contained" type="submit" disabled={!canSave || loading}>
          Сохранить
        </PrimaryButton>
      </ActionsRow>
    </Stack>
  );
};
